import React, {useCallback, useRef, useState} from 'react';
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";

const DemandForm = () => {
    const contactForm = useRef(null);
    const name = useRef(null);
    const email = useRef(null);
    const tel = useRef(null);
    const message = useRef(null);
    const fileRef = useRef(null);

    const [file, setFile] = useState('');
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);

    const { executeRecaptcha } = useGoogleReCaptcha();

    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }

        return await executeRecaptcha('demand_form');
        // Do whatever you want with the token
    }, [executeRecaptcha]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        const captchaToken = await handleReCaptchaVerify();
        if (name.current.value === '') {
            alert('Zadajte meno a priezvisko!');
            return;
        }
        if (!validateEmail(email.current.value)) {
            alert('Neplatný formát e-mailu!');
            return;
        }
        if (tel.current.value === '') {
            alert('Zadajte telefónne číslo!');
            return;
        }

        if (message.current.value === '') {
            alert('Vyplňte správu!');
            return;
        }

        const data = new FormData(e.target);
        data.append('captcha', captchaToken);

        setSending(true);

        fetch('/ajax/demand-form.php', {
            'method': 'POST',
            body: data
        }).then(result => {
            return result.json();
        }).then(data => {
            const msg = data.msg;
            const code = data.code;
            if (code === 1) {
                contactForm.current.reset();

                setFile('');
                setSent(true);
                setSending(false);

                alert('Ďakujeme, budeme Vás kontaktovať');
            } else {
                alert(msg);
            }
        })
    }

    const validateEmail = (email) => {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    const handleFile = () => {
        setFile(fileRef.current.files[0].name);
    }

    const truncate = (source, size) => {
        return source.length > size ? source.slice(0, size - 1) + "…" : source;
    }

    return (
        <React.Fragment>
            {/*<h3>NADPIS</h3>*/}
            <form method="post"
                  onSubmit={handleSubmit}
                  ref={contactForm}>

                <div className="form-group">
                    <label htmlFor="name" className="form-label">Meno</label>
                    <input ref={name} type="text" className="form-control" name="name"
                           id="name"/>
                </div>
                <div className="row">
                    <div className="form-group col-sm-6 col-12">
                        <label htmlFor="email" className="form-label">E-mail</label>
                        <input type="text" className="form-control" name="email" id="email"
                               ref={email}/>
                    </div>
                    <div className="form-group col-sm-6 col-12">
                        <label htmlFor="phone" className="form-label">Telefón</label>
                        <input type="text" className="form-control" name="phone" id="phone"
                               ref={tel}/>
                    </div>
                </div>
                <div className="form-group">
                    <label htmlFor="text" className="form-label">Správa</label>
                    <textarea className="form-control" name="text" id="text" ref={message}></textarea>
                </div>
                <label className="label-file" htmlFor="file">Priložiť prílohy</label>
                <input onChange={handleFile}
                       ref={fileRef}
                       type="file"
                       name="file"
                       id="file"/>
                <span className="file-name">{file ? truncate(file, 12) : "Žiadny súbor"}</span>
                <div className="clearfix"></div>
                <button disabled={sending} type="submit"
                        className="btn pink">{sending ? 'Odosielam...' : 'Odoslať'}</button>
            </form>
        </React.Fragment>
    );
}

export default DemandForm;